import angular from 'angular';
import Colorizer from './colorizer.service';

export default angular.module('dbm.dashboard.shared.colorizer', [])
.service('colorizer', Colorizer)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/colorizer/index.js